const domains = {
	"www.gewinnspiel-hawaiian-tropic.de": {
		env: "prod",
		apibase: "/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
	"gewinnspiel-hawaiian-tropic.de": {
		env: "prod",
		apibase: "/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
	"hawaiian-tropic-gewinnspiel.de": {
		env: "prod",
		apibase: "/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
	"www.hawaiian-tropic-gewinnspiel.de": {
		env: "prod",
		apibase: "/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
	"prod.fe.cam-loy-magellan-hawaiian-tropic-2026-frontend.campaign-loyalty.com": {
		env: "prod",
		apibase: "/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
	"int.fe.cam-loy-magellan-hawaiian-tropic-2026-frontend.campaign-loyalty.com": {
		env: "stage",
		apibase: "/inte/",
		recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C",
	},
}
export const getEnvConfig = () => {
	return domains[window.location.host] || { env: "stage", apibase: "/inte/", recaptchakey: "6Lcwxx8qAAAAAMk6Zz9QTup3mT8AEHCVdx0e152C" }
}
